module.exports = __webpack_public_path__ + "26b0e13f2fd698d822bb83d9ad18404f.svg";